import Main from '@/views/Main.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
    path: '/login',
    name: 'login',
    meta: {
        title: 'Login - 登录'
    },
    component: resolve => { require(['@/views/login.vue'], resolve); }
};

export const page404 = {
    path: '/*',
    name: 'error-404',
    meta: {
        title: '404-页面不存在'
    },
    component: resolve => { require(['@/views/error-page/404.vue'], resolve); }
};

export const page403 = {
    path: '/403',
    meta: {
        title: '403-权限不足'
    },
    name: 'error-403',
    component: resolve => { require(['@//views/error-page/403.vue'], resolve); }
};

export const page500 = {
    path: '/500',
    meta: {
        title: '500-服务端错误'
    },
    name: 'error-500',
    component: resolve => { require(['@/views/error-page/500.vue'], resolve); }
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
    path: '/',
    name: 'otherRouter',
    redirect: '/home',
    // redirect: '/transaction',
    component: Main,
    children: [
         { path: 'home', title: {i18n: 'home'}, name: 'home_index', component: resolve => { require(['@/views/home.vue'], resolve); } },
         { path: 'transaction', title: {i18n: 'transaction'}, name: 'transaction_index', component: resolve => { require(['@/views/transaction.vue'], resolve); } },
         { path: 'transactionDetail', title: {i18n: 'transactionDetail'}, name: 'transaction_detail', component: resolve => { require(['@/views/transactionDetail.vue'], resolve); } },
         { path: 'report', title: {i18n: 'report'}, name: 'report_detail', component: resolve => { require(['@/views/report.vue'], resolve); } },
         { path: 'setting', title: {i18n: 'setting'}, name: 'setting_index', component: resolve => { require(['@/views/setting.vue'], resolve); } },
         { path: 'mine', title: {i18n: 'mine'}, name: 'mine_index', component: resolve => { require(['@/views/mine.vue'], resolve); } },
    ]
};

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
    loginRouter,
    otherRouter,
    //preview,
    //locking,
    //...appRouter,
    page500,
    page403,
    page404
];



// WEBPACK FOOTER //
// ./src/router/router.js